import {ABILITY_GRUNG_POISON_SKIN} from '@/constants/creatureAbilityList'
import {CREATURE_GRUNG_ELITE_WARRIOR} from '@/constants/creatureIdList'
import {faTint} from '@fortawesome/free-solid-svg-icons'

import grungPoisonSkinPostText from './constants/grungPoisonSkinPostText'

export default {
  templateName: 'Яд оранжевого грунга',
  templateIcon: faTint,
  templateColor: 'orange',
  templateLimitations: {
    include: {
      id: [
        CREATURE_GRUNG_ELITE_WARRIOR,
      ],
    },
  },

  name: 'Оранжевый грунг',

  editPropCollection: {
    featureList: ({ featureList }) => featureList.map(
      feature => feature.id === ABILITY_GRUNG_POISON_SKIN
        ? {
          ...feature,
          name: `${feature.name} оранжевого грунга`,
          description: `${feature.description} ${grungPoisonSkinPostText}`.replace(
            `Отравленное существо`,
            'Отравленное существо боится своих союзников. Отравленное существо'
          )
        }
        : feature,
    ),
  },
}
